 <!-- 账号设置 -->
<template>
  <div class="enroll">
    <div class="head">
      <div class="head-left"> 
        <p class="title">账号设置</p>
      </div>
    </div>
   
    <div class="manage">
      <ul class="manage-ul">
        <li class="manage-ul-li">
          <img src="../../assets/img/icon29.png" alt="">
          <div class="manage-ul-li-left">
            <div class="manage-ul-li-left-phone">
              <p class="manage-ul-li-left-phone-key">手机号码</p>
              <p class="manage-ul-li-left-phone-val">{{params.mobile}}</p>
            </div>
            <div>
              <el-button class="buttonl" size="small" style="border: 1px solid #f25e0a;color: #f25e0a;width: 90px;" @click="onVisible(1)">更改</el-button>
            </div>
          </div>
        </li>
        <li class="manage-ul-li">
          <img src="../../assets/img/icon30.png" alt="">
          <div class="manage-ul-li-left">
            <div class="manage-ul-li-left-phone">
              <p class="manage-ul-li-left-phone-key">邮件地址</p>
              <p class="manage-ul-li-left-phone-val">{{params.email}}</p>
            </div>
            <div>
              <el-button class="buttonl" size="small" style="border: 1px solid #f25e0a;color: #f25e0a;width: 90px;" @click="onVisible(2)">更改</el-button>
            </div>
          </div>
        </li>
        <li class="manage-ul-li">
          <img src="../../assets/img/icon31.png" alt="">
          <div class="manage-ul-li-left">
            <div class="manage-ul-li-left-phone">
              <p class="manage-ul-li-left-phone-key">密码</p>
              <p class="manage-ul-li-left-phone-val">已设置</p>
            </div>
            <div>
              <el-button class="buttonl" size="small" style="border: 1px solid #f25e0a;color: #f25e0a;width: 90px;" @click="onVisible(3)">更改</el-button>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <div class="popup">
      
      <el-dialog title="" :visible.sync="dialogFormVisible">
        <p class="popup-title">{{status==3?'更改密码':(status==1?'更改手机号':'更改邮箱')}}</p>
        <div class="popup-form">
          <el-form label-position="top" :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
            <!-- 更改密码 -->
            <div v-if="status==3">
              <el-form-item label="旧密码：" prop="oldPwd" label-width="120px">
                <el-input type="password" v-model="ruleForm.oldPwd" placeholder="请输入旧密码"></el-input>
              </el-form-item>
              <el-form-item label="新密码：" prop="newPwd" label-width="120px">
                <el-input type="password" v-model="ruleForm.newPwd" placeholder="请输入新密码"></el-input>
              </el-form-item>
              <el-form-item label="重置密码：" prop="resetting" label-width="120px">
                <el-input type="password" v-model="ruleForm.resetting" placeholder="请输入再次输入密码"></el-input>
              </el-form-item>
            </div>

            <!-- 更改手机号 -->
            <div v-else-if="status==1">
              <el-form-item label="旧手机号：" prop="oldMobile" label-width="120px">
                <el-input v-model="ruleForm.oldMobile" placeholder="请输入旧手机号"></el-input>
              </el-form-item>
              <el-form-item label="验证码：" prop="oldCheckCode" label-width="120px" class="code">
                <el-input v-model="ruleForm.oldCheckCode" placeholder="请输入旧手机号验证码"></el-input>
                <el-button size="small" type="warning" :loading="loadingl" @click="submitCode(1,1)" :disabled="countdownl > 0" style="padding: 14px 30px;margin-left: 10px;background-color: #ff821c"> {{ countdownl > 0 ? `${countdownl}秒后重新获取` : '获取验证码' }}</el-button>
              </el-form-item>
              <el-form-item label="新手机号：" prop="newMobile" label-width="120px">
                <el-input v-model="ruleForm.newMobile" placeholder="请输入新手机号"></el-input>
              </el-form-item>
              <el-form-item label="验证码：" prop="newCheckCode" label-width="120px" class="code">
                <el-input v-model="ruleForm.newCheckCode" placeholder="请输入新手机号验证码"></el-input>
                <el-button size="small" type="warning" :loading="loadingn" @click="submitCode(1,2)" :disabled="countdownn > 0" style="padding: 14px 30px;margin-left: 10px;background-color: #ff821c"> {{ countdownn > 0 ? `${countdownn}秒后重新获取` : '获取验证码' }}</el-button>
              </el-form-item>
            </div>

            <!-- 更改邮箱 -->
            <div v-else>
              <el-form-item label="旧邮箱：" prop="oldEmail" label-width="120px">
                <el-input v-model="ruleForm.oldEmail" placeholder="请输入旧邮箱"></el-input>
              </el-form-item>
              <!-- <el-form-item label="验证码：" prop="oldeCode" label-width="120px" class="code">
                <el-input v-model="ruleForm.oldeCode" placeholder="请输入旧邮箱验证码"></el-input>
                <el-button size="small" type="warning" :loading="loadingl" @click="submitCode(2,1)" :disabled="countdownl > 0" style="padding: 14px 30px;margin-left: 10px;background-color: #ff821c"> {{ countdownl > 0 ? `${countdownl}秒后重新获取` : '获取验证码' }}</el-button>
              </el-form-item> -->
              <el-form-item label="登录密码：" prop="loginPwd" label-width="120px">
                <el-input type="password" v-model="ruleForm.loginPwd" placeholder="请输入登录密码"></el-input>
              </el-form-item>
              <el-form-item label="新邮箱：" prop="newEmail" label-width="120px">
                <el-input v-model="ruleForm.newEmail" placeholder="请输入新邮箱"></el-input>
              </el-form-item>
              <el-form-item label="验证码：" prop="neweCode" label-width="120px" class="code">
                <el-input v-model="ruleForm.neweCode" placeholder="请输入新邮箱验证码"></el-input>
                <el-button size="small" type="warning" :loading="loadingn" @click="submitCode(2,2)" :disabled="countdownn > 0" style="padding: 14px 30px;margin-left: 10px;background-color: #ff821c"> {{ countdownn > 0 ? `${countdownn}秒后重新获取` : '获取验证码' }}</el-button>
              </el-form-item>
            </div>
            <el-form-item style="text-align: center;margin-top: 50px">
              <el-button size="small" type="warning" @click="submitForm('ruleForm')" :loading="loading" style="padding: 14px 100px;background-color: #ff821c">提交</el-button>
              <el-button class="buttonl" size="small" style="border: 1px solid #f25e0a;color: #f25e0a;padding: 14px 100px;" @click="resetForm('ruleForm')">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
    </div>
    
  </div>
</template>

<script scoped>
import {userInfo,getPhoneCheckCode,getEmail,changeMobileBind,editPassword } from '../../api/userMG'
import md5 from 'js-md5';
export default {
  data() {
    var resetting = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.ruleForm.newPwd) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      dialogFormVisible:false,
      status:1,
      ruleForm:{
        oldPwd:'',
        newPwd:'',
        resetting:'',
        oldMobile:'',
        oldCheckCode:'',
        newMobile:'',
        newCheckCode:'',
        oldEmail:'',
        oldeCode:'',
        newEmail:'',
        loginPwd:'',
        neweCode:'',
      },
      rules: {
        oldPwd: [
          { required: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        newPwd: [
          { required: true, message: '请输入新密码', trigger: 'blur' }
        ],
        resetting: [
          { validator: resetting, trigger: 'blur' }
        ],
        oldMobile: [
          { required: true, message: '请输入旧手机号', trigger: 'blur' }
        ],
        oldCheckCode: [
          { required: true, message: '请输入旧手机号验证码', trigger: 'blur' }
        ],
        newMobile: [
          { required: true, message: '请输入新手机号', trigger: 'blur' }
        ],
        newCheckCode: [
          { required: true, message: '请输入新手机号验证码', trigger: 'blur' }
        ],
        oldEmail: [
          { required: true, message: '请输入旧邮箱', trigger: 'blur' }
        ],
        oldeCode: [
          { required: true, message: '请输入旧邮箱验证码', trigger: 'blur' }
        ],
        newEmail: [
          { required: true, message: '请输入新邮箱', trigger: 'blur' }
        ],
        neweCode: [
          { required: true, message: '请输入新邮箱验证码', trigger: 'blur' }
        ],
        loginPwd: [
          { required: true, message: '请输入登录密码', trigger: 'blur' }
        ]
      },
      loading:false,
      params:{},

      intervalId1: null, // 存储interval的id

      countdownl: 0, // 倒计时秒数
      loadingl:false,

      countdownn: 0, // 倒计时秒数
      loadingn:false
    }
  },
  created() {
    this.getUserInfo()
  },
  methods:{
    async getUserInfo(){
      await userInfo().then(res => {
          console.log('用户信息',res);
          this.params = res.data;
          this.ruleForm.oldMobile = res.data.mobile;
          this.ruleForm.oldEmail = res.data.email;
      })
    },
    onVisible(e){
      this.countdownl = 0;
      this.countdownn = 0;
      this.status = e;
      this.dialogFormVisible = true;
    },
    resetForm(formName) {
      this.dialogFormVisible = false;
      this.$refs[formName].resetFields();
    },

    // 发送验证码
    submitCode(i,e){
      // 更换手机号
      let oldSign;
      let newSign;
      if(i==1){
        if(e == 1 && !this.ruleForm.oldMobile){
          this.$message({
            message: '请输入旧手机号',
            type: 'warning',
            offset:100
          });
          return
        }
        if(e == 2 && !this.ruleForm.newMobile){
          this.$message({
            message: '请输入新手机号',
            type: 'warning',
            offset:100
          });
          return
        }
        oldSign = md5(this.ruleForm.oldMobile+'ZHE_GE_JIE_KOU_YI_JIN_JIA_MI_LE');
        newSign = md5(this.ruleForm.newMobile+'ZHE_GE_JIE_KOU_YI_JIN_JIA_MI_LE');

      // 更换邮箱
      }else{
        if(e == 1 && !this.ruleForm.oldEmail){
          this.$message({
            message: '请输入旧邮箱',
            type: 'warning',
            offset:100
          });
          return
        }
        if(e == 2 && !this.ruleForm.newEmail){
          this.$message({
            message: '请输入新邮箱',
            type: 'warning',
            offset:100
          });
          return
        }
      }
      let params;
      let account;
      if(i==1){
        params = {
          phoneNum:e==1?this.ruleForm.oldMobile:this.ruleForm.newMobile,
          sign:e==1?oldSign:newSign
        }
        account = getPhoneCheckCode;
      }else{
        params = {
          email:e==1?this.ruleForm.oldEmail:this.ruleForm.newEmail,
        }
        account = getEmail;
      }
      if(e==1){
        this.loadingl = true;
      }else{
        this.loadingn = true;
      }
      account(params).then(res => {
        console.log('验证码',res);
        if(e==1){
          this.loadingl = false;
        }else{
          this.loadingn = false;
        }
        if(res.code==0){
          this.$message({
            message: '验证码已发送！',
            type: 'success',
            offset:100
          });
          if(e==1){
            this.startCountdownl(60);
          }else{
            this.startCountdownn(60);
          }
        }
      })
      .catch(err => {
        if(e==1){
          this.loadingl = false;
        }else{
          this.loadingn = false;
        }
      })
    },

    // 验证码倒计时
    startCountdownl(seconds) {
      this.countdownl = seconds;
      this.intervalId1 = setInterval(() => {
        if (this.countdownl > 0) {
          this.countdownl -= 1;
        } else {
          clearInterval(this.intervalId1);
        }
      }, 1000);
    },
    startCountdownn(seconds) {
      this.countdownn = seconds;
      this.intervalIdn = setInterval(() => {
        if (this.countdownn > 0) {
          this.countdownn -= 1;
        } else {
          clearInterval(this.intervalIdn);
        }
      }, 1000);
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {

          this.loading = true;
          let Mobile;
          let account;
          if(this.status==3){
            Mobile = {
              newPwd: this.ruleForm.newPwd,
              oldPwd: this.ruleForm.oldPwd,
            }
            account = editPassword;
          }else if(this.status==1){
            Mobile = {
              newCheckCode: this.ruleForm.newCheckCode,
              newMobile: this.ruleForm.newMobile,
              oldCheckCode: this.ruleForm.oldCheckCode,
              oldMobile: this.ruleForm.oldMobile,
              type:1
            }
            account = changeMobileBind;
          }else{
            Mobile = {
              newCheckCode: this.ruleForm.neweCode,
              newMobile: this.ruleForm.newEmail,
              // oldCheckCode: this.ruleForm.oldeCode,
              loginPwd: this.ruleForm.loginPwd,
              oldMobile: this.ruleForm.oldEmail,
              type:2
            }
            account = changeMobileBind;
          }
          
          account(Mobile).then(res => {
            if(res.code==0){
              console.log(res)
              if(this.status==3){
                this.$message({
                  message: '密码已更换！',
                  type: 'success',
                  offset:100
                });
              }else if(this.status==1){
                this.$message({
                  message: '手机号已更换！',
                  type: 'success',
                  offset:100
                });
              }else{
                this.$message({
                  message: '邮箱已更换！',
                  type: 'success',
                  offset:100
                });
              }
              this.dialogFormVisible = false;
            }
            this.loading = false;
          })
          .catch(err => {
            this.loading = false;
          })
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style scoped>
  .enroll{
    padding: 30px 20px 50px;
    background-image: linear-gradient(bottom,#fff,#fff8f2);
    border: 1px solid #e1e2e6;
    border-radius: 8px;
  }
  .head{
    display: flex;
    justify-content: space-between;
    border-bottom: solid 1px #e6e6e6;
  }
  .head .title{
    font-size: 14px;
    font-weight: 500;
    color: black;
    letter-spacing: 1px;
    margin-bottom: 15px;
  }
  
  .popup /deep/ .el-dialog__header{
    padding: 0;
  }
  .popup /deep/ .el-dialog__body{
    padding: 0;
  }
  .el-dialog__headerbtn .el-dialog__close{
    color: #fff;
    font-size: 19px;
  }
   .popup /deep/ .el-dialog{
    border-radius: 8px;
  }
  .popup /deep/ .el-dialog__headerbtn .el-dialog__close{
    color: #fff;
  }

  .popup-title{
    background: #ff821e;
    color: #fff;
    font-size: 16px;
    padding: 20px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
  .popup-form{
    padding: 40px 110px;
  }
  .buttons{
    color: #f35903;
    border:1px solid #f35903;
  }
  .buttons:hover{
    background: none;
  }
  .manage{
    margin-top: 20px;
  }
  .manage-ul-li{
    display: flex;
    align-items: center;
  }
  .manage-ul-li-left{
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    border-bottom: 1px solid #f6f6f6;
    padding: 26px 0;
  }
  .manage-ul-li img{
    width: 46px;
    height: 46px;
    margin-right: 20px;
  }
  .manage-ul-li-left-phone-key{
    font-size: 13px;
    color: black;
    margin-bottom: 5px;
  }
  .manage-ul-li-left-phone-val{
    font-size: 11px;
    color: #676767;
  }
  .code /deep/ .el-form-item__content{
  display: flex;
  }
  .buttonl:hover{
    background: none;
  }
</style>


// WEBPACK FOOTER //
// src/views/manage/manage.vue